import { ROLES } from 'constants/enums'

export default function(data) {
  if (!data) {
    return []
  }

  const allRoles = [
    {
      role: 'isAwardLeader',
      status: data.isAwardLeader,
      defaultMessage: 'Award Leader',
      intlKey: 'roles.leader',
      value: ROLES.LEADER.role
    },
    {
      role: 'isNaaOaStaff',
      status: data.isNaaOaStaff,
      defaultMessage: 'NAO staff',
      intlKey: 'roles.nao_staff',
      value: ROLES.NAO_STAFF.role
    },
    {
      role: 'isAwardVerifier',
      status: data.isAwardVerifier,
      defaultMessage: 'Award verifier',
      intlKey: 'roles.award_verifier',
      value: ROLES.AWARD_VERIFIER.role
    },
    {
      role: 'isCoordinator',
      status: data.isCoordinator,
      defaultMessage: 'Coordinator',
      intlKey: 'roles.coordinator',
      value: ROLES.COORDINATOR.role
    },
    {
      role: 'isAjAssessor',
      status: data.isAjAssessor,
      defaultMessage: 'AJ assessor',
      intlKey: 'roles.aj_assessor',
      value: ROLES.AJ_ASSESSOR.role
    },
    {
      role: 'isAjSupervisor',
      status: data.isAjSupervisor,
      defaultMessage: 'AJ supervisor',
      intlKey: 'roles.aj_supervisor',
      value: ROLES.AJ_SUPERVISOR.role
    },
    {
      role: 'isAjInstructor',
      status: data.isAjInstructor,
      defaultMessage: 'Instructor',
      intlKey: 'roles.instructor',
      value: ROLES.AJ_INSTRUCTOR.role
    },
    {
      role: 'isIfStaffSuperuser',
      status: data.isIfStaffSuperuser,
      defaultMessage: 'Super user',
      intlKey: 'roles.super_user',
      value: ROLES.IF_STAFF_SUPER.role
    },
    {
      role: 'isIfStaffStatisticalUser',
      status: data.isIfStaffStatisticalUser,
      defaultMessage: 'Statistical',
      intlKey: 'roles.user',
      value: ROLES.IF_STAFF_USER.role
    },
    {
      role: 'isIfStaffViewer',
      status: data.isIfStaffViewer,
      defaultMessage: 'Viewer',
      intlKey: 'roles.viewer',
      value: ROLES.IF_STAFF_VIEWER.role
    },
    {
      role: 'isAssessor',
      status: data.isAssessor,
      defaultMessage: 'Assessor',
      intlKey: 'roles.assessor',
      value: ROLES.ASSESSOR.role
    }
  ]

  return allRoles.filter(item => item.status)
}
